import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import LeftIcon from '@material-ui/icons/ArrowLeft';
import RightIcon from '@material-ui/icons/ArrowRight';
import UnassignIcon from '@material-ui/icons/LinkOff';
import environment from '../../environments';
import moment from 'moment'
import 'moment-timezone';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    }
});

class DataTable extends Component
{

    goToDetails(id)
    {
        this.props.history.push(
            this.props.detailRoute ? this.props.detailRoute + "/" + id : this.props.store.detailRoute + "/" + id)
    }

    renderCell(item, column, index)
    {
        switch (column.type)
        {
            case 'deleteButton':
                return <TableCell key={index}>
                    <IconButton aria-label="Delete" onClick={() => this.props.deleteFunction(item.uuid)}>
                        <UnassignIcon fontSize="small"/>
                    </IconButton>
                </TableCell>
            case 'text':
                return <TableCell key={index} onClick={() => this.goToDetails(item.uuid)}>{item[column.field]}</TableCell>;
            case 'bool':
                return <TableCell key={index} onClick={() => this.goToDetails(item.uuid)}>{item[column.field] ? "Ja" :
                    "Nein"}</TableCell>;
            case 'orderType':
                return <TableCell key={index} onClick={
                    () => this.goToDetails(item.uuid)}>{item[column.field] === "stickers" ? "Sticker" :
                    item[column.field] === "pendants" ? "3er-Anhänger" : "Karten"
                }</TableCell>;
            case 'date':
                return <TableCell key={index} onClick={() => this.goToDetails(item.uuid)}>{item[column.field] ?
                    moment(item[column.field]).format("DD.MM.YYYY / HH:mm") : 'Nie'}</TableCell>;
            case 'image':
                return <TableCell key={index} onClick={() => this.goToDetails(item.uuid)}><img height="20" width="20"
                                                                                               src={item[column.field] ?
                                                                                                   environment.CDN_HOST + "/" +
                                                                                                   item[column.field] : require(
                                                                                                       "../../assets/img/logo-placeholder.png")}
                                                                                               alt={item[column.field]}/></TableCell>;
            default:
                return <TableCell key={index} onClick={() => this.goToDetails(item.uuid)}>{item[column.field]}</TableCell>;
        }
    }

    render()
    {
        const {classes} = this.props;
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {this.props.columns.map((column, index) =>
                                    <TableCell key={index}>
                                        {(column.sortable) &&
                                            <Tooltip
                                                title="Klicken zum sortieren"
                                                placement={'bottom-end'}
                                                enterDelay={300}>
                                                <TableSortLabel
                                                    active={column.field === this.props.store.sortBy}
                                                    direction={this.props.store.sortOrder}
                                                    onClick={() => this.props.store.sort(column.field)}>
                                                    {column.name}
                                                </TableSortLabel>
                                            </Tooltip>
                                        }
                                        {(!column.sortable) &&
                                            <div>{column.name}</div>
                                        }
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.rows.map((item, index) =>
                                <TableRow key={index} style={{cursor: "pointer"}}>
                                    {this.props.columns.map((column, index) =>
                                        this.renderCell(item, column, index)
                                    )}
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={this.props.columns.length}>
                                    {(this.props.store.start > 0) &&
                                        <Button size="small" onClick={() => this.props.store.previousPage()}>
                                            <LeftIcon className={classes.rightIcon}/> Vorherige Seite
                                        </Button>
                                    }
                                    {(this.props.rows.length >= this.props.store.limit && this.props.store.hasNextPage !== false) &&
                                        <Button size="small" onClick={() => this.props.store.nextPage()}>
                                            Nächste Seite <RightIcon className={classes.rightIcon}/>
                                        </Button>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(DataTable);
